import './styles.scss';

import { SocialLinksAd } from 'shared/components/social-links-ad/SocialLinksAd';

export const adsDisplayDelayMilliseconds = 2000;

export const googleAdSenceId = 'ca-pub-9739257346042377';

export interface AdSetting {
	yandexId: string;
	googleId: string;
	internalId?: string;
}

export interface InternalAdSetting {
	isEnabled: boolean;
	component: () => JSX.Element;
	showRemoveAdBlock: boolean;
}

const rusetfsSocialLinks = 'rusetfsSocialLinks';

export const internalSettings: { [key: string]: InternalAdSetting} = {
	[rusetfsSocialLinks]: { isEnabled: true, component: () => <SocialLinksAd />, showRemoveAdBlock: false }
}

export const settings: { [key: string]: AdSetting} = {
	'screener:desktop': { yandexId: 'R-A-513487-19', googleId: '1878801763' },
	'screener:mobile': { yandexId: 'R-A-513487-20', googleId: '3222128432', internalId: rusetfsSocialLinks },
	'MapFirst:desktop': { yandexId: 'R-A-513487-9', googleId: '7534148231' },
	'MapFirst:mobile': { yandexId: 'R-A-513487-17', googleId: '8196315608' },
	'MapSecond:desktop': { yandexId: 'R-A-513487-10', googleId: '5893037153' },
	'MapSecond:mobile': { yandexId: 'R-A-513487-18', googleId: '4257070590' },
	'EtfInfo:Left:desktop': { yandexId: 'R-A-513487-22', googleId: '1458497300' },
	'EtfInfo:Left:mobile': { yandexId: 'R-A-513487-23', googleId: '1458497300' },

	'InfoDetailedHorizontal1': { yandexId: '', googleId: '', internalId: rusetfsSocialLinks },
	'InfoDetailedHorizontal2:desktop': { yandexId: 'R-A-513487-24', googleId: '4906549697' },
	'InfoDetailedHorizontal2:mobile': { yandexId: 'R-A-513487-25', googleId: '4906549697' },
};